import { gql } from '@apollo/client'

export const GET_USER_TORCH_APPLICATIONS = gql`
  query getUserTorchApplications {
    torchApplications {
      id
      type
      status
      projectId
      data {
        title
        isResubmission
        resubmissionStatus
      }
    }
  }
`

export const GET_USER_TORCH_APPLICATION = gql`
  query getUserTorchApplication($id: ID!) {
    torchApplication(id: $id) {
      id
      type
      status
      projectId
      data {
        isResubmission
        resubmissionStatus
        torchId
        torchAcknowledgement
        title
        description
        productionType
        presentationType
        genres
        audience
        ages
        otherGenre
        fundingNeeded
        productionStage
        companyName
        addressLine1
        addressLine2
        city
        state
        zipCode
        country
        copyrightName
        filmmakerRole
        filmmakerFilmRole
        filmmakerName
        filmmakerEmail
        filmmakerPhone
        signatureDate
        uploadAcknowledgements
        source
        applyingForFunding
        paymentDate
        allowShares
        hasFilmBeenDistributed
      }
    }
  }
`

export const GET_SIGNED_PDF_URL = gql`
  query getSignedPdfUrl($id: ID!) {
    torchApplication(id: $id) {
      id
      signedPdfUrl
    }
  }
`

export const CREATE_TORCH_APPLICATION = gql`
  mutation createTorchApplication($input: CreateTorchApplicationInput!) {
    createTorchApplication(input: $input) {
      id
    }
  }
`

export const UPDATE_TORCH_APPLICATION = gql`
  mutation updateTorchApplication($input: UpdateTorchApplicationInput!) {
    updateTorchApplication(input: $input) {
      id
    }
  }
`

export const GET_UPLOAD_URL = gql`
  query getUploadUrl($id: ID!, $fileName: String!) {
    torchApplication(id: $id) {
      id
      uploadUrl(fileName: $fileName)
    }
  }
`

export const GET_FILMMAKER_UPLOAD_URL = gql`
  query getFilmmakerUploadUrl($input: FilmmakerUploadInput) {
    filmmakerUploadUrl(input: $input)
  }
`

export const CREATE_MULTIPART_UPLOAD = gql`
  mutation createMultipartUpload($input: CreateFilmmakerMultipartUploadInput!) {
    createFilmmakerMultipartUpload(input: $input) {
      uploadId
    }
  }
`

export const COMPLETE_MULTIPART_UPLOAD = gql`
  mutation completeMultipartUpload($input: CompleteFilmmakerMultipartUploadInput!) {
    completeFilmmakerMultipartUpload(input: $input)
  }
`

export const ABORT_MULTIPART_UPLOAD = gql`
  mutation abortMultipartUpload($input: AbortFilmmakerMultipartUploadInput!) {
    abortFilmmakerMultipartUpload(input: $input)
  }
`

export const COMPLETE_UPLOAD = gql`
  mutation completeFilmmakerUpload($input: FilmmakerUploadInput) {
    completeFilmmakerUpload(input: $input)
  }
`

export const GET_MULTIPART_UPLOAD_URL = gql`
  query getMultipartUploadUrl($id: ID!, $fileName: String!, $uploadId: String!, $part: Int!) {
    torchApplication(id: $id) {
      id
      uploadMultipartUrl(fileName: $fileName, uploadId: $uploadId, part: $part)
    }
  }
`

export const GET_FILMMAKER_MULTIPART_UPLOAD_URL = gql`
  query getFilmmakerMultipartUploadUrl($input: FilmmakerUploadInput) {
    filmmakerUploadMultipartUrl(input: $input)
  }
`

export const GET_UPLOADED_FILES = gql`
  query getUploadedFiles($id: ID!) {
    torchApplication(id: $id) {
      id
      uploads {
        fileName
        size
        type
        alias
        status
      }
    }
  }
`

export const GET_FILMMAKER_UPLOADED_FILES = gql`
  query getFilmmakerUploadedFiles($input: FilmmakerUploadInput) {
    filmmakerUploads(input: $input) {
      fileName
      size
      type
      url
    }
  }
`

export const DELETE_UPLOADED_FILE = gql`
  mutation deleteUploadedFile($input: DeleteTorchApplicationUploadInput!) {
    deleteTorchApplicationUpload(input: $input)
  }
`

export const DELETE_FILMMAKER_UPLOAD_FILE = gql`
  mutation deleteFilmmakerUploadedFile($input: DeleteFilmmakerUploadInput!) {
    deleteFilmmakerUpload(input: $input)
  }
`

export const CREATE_TORCH_APPLICATION_STRIPE_CHECKOUT = gql`
  mutation createTorchApplicationStripeCheckout($input: TorchApplicationStripeCheckoutInput!) {
    createTorchApplicationStripeCheckout(input: $input) {
      clientSecret
    }
  }
`

export const GET_GUILD_MEMBERSHIP_COUNT = gql`
  query getGuildMembershipCount {
    guildMembershipCount
  }
`

export const UPDATE_TORCH_APPLICATION_ALIAS = gql`
  mutation updateApplicationAssetAlias($input: UpdateApplicationAssetAliasInput!) {
    updateApplicationAssetAlias(input: $input)
  }
`
